import React from 'react';
import 'core/styles/globals.scss';
import { BrowserRouter } from 'react-router-dom';
import { PmxDashboard } from './routes/pmx-dashboard';
import { Provider } from 'react-redux';
import { store } from 'core/redux/store';
import { Toaster } from 'react-hot-toast';
import { ConfigProvider } from 'antd';
import faIR from 'antd/lib/locale/fa_IR';

function App() {
    return (
        <Provider store={store}>

            <Toaster position={'top-right'} />
            <title>پی ام ایکس چنج </title>
            <meta name="description" content="پی ام ایکس چنج | پنل ادمین" />

            <BrowserRouter>
                <ConfigProvider locale={faIR}>
                    <PmxDashboard />
                </ConfigProvider>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
